import './InitiativeSidebar.scss';

import classNames from 'classnames';
import { InitiativeSidebarStatusSelector } from './SidebarStatusSelector';
import { InitiativeTagsSection } from './InitiativeTagsSection';
import { SonarText } from '@ui/text';
import { SonarUser } from '@ui/SonarUser';
import { UserSelector } from '@ui/UserSelector';

import { coreActions, InitiativeStatus } from '@sonar-software/sonar-core';
import { INITIATIVES_SIDEBAR_LABELS, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';
import { useAction, useCurrentUser } from '@hooks';

export interface InitiativeSidebarProps {
	assignedTo: number;
	createdBy: number;
	initiativeId: number;
	status: InitiativeStatus | undefined;
}

export const InitiativeSidebar: React.FC<InitiativeSidebarProps> = ({
	assignedTo,
	createdBy,
	initiativeId,
	status
}) => {
	const { isReadOnly } = useCurrentUser();
	const updateInitiative = useAction(coreActions.requestPatchCoreInitiativesById);

	const handleChangeOwner = useCallback(
		(newAssignedTo: number | undefined) => {
			updateInitiative({
				initiativeId: initiativeId,
				patchInitiativeDescription: {
					assignedTo: newAssignedTo
				}
			});
		},
		[ initiativeId, updateInitiative ]
	);

	const readOnlyClassnames = classNames({ 'read-only': isReadOnly });

	return (
		<div className='initiative-sidebar'>
			<InitiativeSidebarStatusSelector
				initiativeId={ initiativeId }
				status={ status } />
			<SonarText className='section-header'>{ INITIATIVES_SIDEBAR_LABELS.CREATED_BY }</SonarText>
			<SonarUser
				avatar
				className='created-by'
				userId={ createdBy || -1 } />
			<SonarText className='section-header'>{ INITIATIVES_SIDEBAR_LABELS.OWNED_BY }</SonarText>
			<div className={ readOnlyClassnames }>
				<UserSelector
					allowClear={ false }
					avatar
					id='initiative-owner-select'
					onSingleChange={ handleChangeOwner }
					placeholder={ PLACEHOLDERS_COPY.ADD_OWNER }
					selectionRequired
					value={ assignedTo } />
			</div>
			<InitiativeTagsSection initiativeId={ initiativeId } />
		</div>
	);
};
